import { GATEWAY_DISPLAY_MODEL } from 'src/features/systems/utils/types';
import { systemsMessages } from 'src/features/systems/utils/messages';

export const DISPLAY_SETTING_ACTIONS = [
    'successful_entrance_message',
    'rejected_entrance_message',
    'successful_exit_message',
    'rejected_exit_message',
    'date_message',
    'spaces_message',
    'lpr_message',
    'ticket_message',
    'card_message',
    'exit_payment_due_amount_message',
    'exit_payment_insert_card_message',
    'exit_payment_card_accepted_message',
    'exit_payment_card_rejected_message',
    'exit_payment_pin_requested_message',
    'exit_payment_processing_message',
    'exit_payment_confirmed_message',
    'exit_payment_failed_message',
] as const;

export type DisplaySettingAction = (typeof DISPLAY_SETTING_ACTIONS)[number];

export const DISPLAY_MODEL_SETTING_PREFIXES: Record<GATEWAY_DISPLAY_MODEL, string> = {
    [GATEWAY_DISPLAY_MODEL.SP]: 'sp',
    [GATEWAY_DISPLAY_MODEL.HUIDU]: 'huidu',
    [GATEWAY_DISPLAY_MODEL.NED200]: 'ned200',
    [GATEWAY_DISPLAY_MODEL.NED200C]: 'ned200c',
};

export const buildDisplaySettingCode = (model: GATEWAY_DISPLAY_MODEL, action: DisplaySettingAction): string =>
    `${DISPLAY_MODEL_SETTING_PREFIXES[model]}_${action}`;

export type DisplayColorOption = { value: string; label: { id: string; defaultMessage: string } };

export const DISPLAY_MODEL_COLOR_OPTIONS: Record<GATEWAY_DISPLAY_MODEL, readonly DisplayColorOption[]> = {
    [GATEWAY_DISPLAY_MODEL.SP]: [],
    [GATEWAY_DISPLAY_MODEL.HUIDU]: [
        { value: '#FFFFFF', label: systemsMessages.white },
        { value: '#60B6FC', label: systemsMessages.lightBlue },
        { value: '#099250', label: systemsMessages.green },
        { value: '#E22028', label: systemsMessages.red },
        { value: '#FF9600', label: systemsMessages.orange },
        { value: '#FFEA00', label: systemsMessages.yellow },
    ],
    [GATEWAY_DISPLAY_MODEL.NED200]: [
        { value: '#099250', label: systemsMessages.green },
        { value: '#E22028', label: systemsMessages.red },
    ],
    [GATEWAY_DISPLAY_MODEL.NED200C]: [
        { value: '#E22028', label: systemsMessages.red },
        { value: '#099250', label: systemsMessages.green },
        { value: '#FFEA00', label: systemsMessages.yellow },
        { value: '#60B6FC', label: systemsMessages.lightBlue },
        { value: '#7F56D9', label: systemsMessages.purple },
        { value: '#00C6D7', label: systemsMessages.cyan },
        { value: '#FFFFFF', label: systemsMessages.white },
    ],
};

export const supportsDisplayColorSettings = (model: GATEWAY_DISPLAY_MODEL): boolean =>
    DISPLAY_MODEL_COLOR_OPTIONS[model].length > 0;

export const isGatewayDisplayModel = (value: string | undefined): value is GATEWAY_DISPLAY_MODEL =>
    !!value && (Object.values(GATEWAY_DISPLAY_MODEL) as string[]).includes(value);
